var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profile-edit-create',{attrs:{"organization-id":_vm.organization.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }